import { Constantes } from './constantes';
import { AuthenticationService } from '../providers/authentication/authentication.service';
import { environment } from '../../environments/environment';

export class EspacioFormulario {
	filter(arg0: (h: any) => boolean): EspacioFormulario {
		throw new Error('Method not implemented.');
	}
	// Alimentar los inputs
	Id: string;
	Nombre: string;
	Descripcion: string;
	PasswordBeacons: string;
	Imagen: string; // fotoblob
	Duracion: string;
	ColorEspacio: string;
	ColorFuenteEspacio: string;
	ColorSeleccionEspacio: string;

	// Indica si se ha de mostrar el boton editar
	editarVisible: boolean;

	Idiomas: Map<string, EspacioIdiomaFormulario>;

	FechaAlta: Date;
	FechaBaja: Date;
	FechaDesde: Date;
	FechaHasta: Date;
	UbicarAnonimos: boolean;
	PantallaPrincipal: Number;
	// Objeto de Breeze
	ENTIDAD: any;
	TIPO: string;
	numeroCONTENIDOS: Number = 0;
	Area: Number;

	constructor(espacio?) {
		this.Nombre = '';
		this.Descripcion = '';
		this.editarVisible = false;
		this.PasswordBeacons = '';
		this.Idiomas = new Map<string, EspacioIdiomaFormulario>();
		this.ENTIDAD = {};
		this.UbicarAnonimos = false;
		//this.PantallaPrincipal =
		this.ColorSeleccionEspacio = 'rgba(184,219,184,0.6)';
		this.ColorFuenteEspacio = 'rgba(255,255,255,1)';
		this.ColorEspacio = 'rgba(100,102,101,1)';
		this.Area = 0;

		if (espacio) {


			/* IDEA para mostrar idioma por defecto
			espacio.IDIOMAS.forEach(element => {
				const aux = new EspacioIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});

			const espacioIdioma = this.Idiomas.get(idiomaDefecto.ENTIDAD.Codigo);

			this.Nombre = espacioIdioma.Nombre;
			this.Descripcion = espacioIdioma.Descripcion;
			*/

			this.ENTIDAD = espacio;
			this.Id = espacio.Id;
			this.Nombre = espacio.Nombre;
			this.Descripcion = espacio.Descripcion;
			this.editarVisible = espacio.editarVisible;
			this.PasswordBeacons = espacio.PasswordBeacons;

			this.ColorEspacio = espacio.ColorEspacio;
			this.ColorFuenteEspacio = espacio.ColorFuenteEspacio;
			this.ColorSeleccionEspacio = espacio.ColorSeleccionEspacio;

			this.FechaAlta = espacio.FechaAlta;
			this.FechaBaja = espacio.FechaBaja;
			this.UbicarAnonimos = espacio.UbicarAnonimos;
			this.PantallaPrincipal = espacio.PantallaPrincipal;
			this.TIPO = this.ENTIDAD .constructor.name.split('_', 2)[0];

			this.Area = espacio.AREA;

			if (this.ENTIDAD.CONTENIDOS) {
				this.numeroCONTENIDOS = this.ENTIDAD .CONTENIDOS.length;
			}

			espacio.IDIOMAS.forEach(element => {
				const aux = new EspacioIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});

			// FOTOS
			const ultima = espacio.FOTOS.length - 1;
			if (ultima >= 0) {
				if (espacio.FOTOS[ultima].UrlFotoExt) {
					this.Imagen = espacio.FOTOS[ultima].UrlFotoExt;
				}
				else{
					this.Imagen =  environment.urlBaseFotos +  espacio.FOTOS[ultima].IdFotoExt;
				}
			}
		}
	}
}

export class EspacioIdiomaFormulario {

	Codigo: string;
	Nombre: string;
	Descripcion: string;

	constructor(espacioIdioma?) {
		if (espacioIdioma) {
			this.Codigo = espacioIdioma.IDIOMA.Codigo ? espacioIdioma.IDIOMA.Codigo : '';
			this.Nombre = espacioIdioma.Nombre ? espacioIdioma.Nombre : '';
			this.Descripcion = espacioIdioma.Descripcion ? espacioIdioma.Descripcion : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
		}
	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/EspacioFormulario.ts